import { render, staticRenderFns } from "./ListRegionPage.vue?vue&type=template&id=253b6ab8&"
import script from "./ListRegionPage.vue?vue&type=script&lang=js&"
export * from "./ListRegionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports